<div class="og-card-container cursor-pointer" (click)="goToShop()">
    <div class="og-card-content" *ngIf="!isLoading; else loading">
        <div class="og-card-image" *ngIf="ogImage">
            <img [src]="ogImage" alt="og image" />
        </div>
        <div class="og-card-texts">
            <div class="og-site-name" *ngIf="siteName">{{ siteName }}</div>
            <div class="og-title" *ngIf="ogTitle || ogDescription">
                <ng-container *ngIf="ogTitle">{{ ogTitle }}</ng-container>
                <ng-container *ngIf="ogTitle && ogDescription"> | </ng-container>
                <ng-container *ngIf="ogDescription">{{ ogDescription }}</ng-container>
            </div>
        </div>
    </div>

    <!-- Skeleton -->
    <ng-template #loading>
        <div class="og-card-content">
            <div class="og-card-image">
                <p-skeleton width="40px" height="40px" borderRadius="4px"></p-skeleton>
            </div>
            <div class="og-card-texts">
                <p-skeleton width="100px" height="16px" class="mb-2"></p-skeleton>
                <p-skeleton width="200px" height="14px"></p-skeleton>
            </div>
        </div>
    </ng-template>
</div>